module.exports = lib_tslib;